import { trpc } from '@/shared/api';
import { useExhibitionImageUpload } from './use-exhibition-image-upload';

interface UseReplaceExhibitionImageOptions {
  readonly onSuccess?: () => void;
}

/** 대표 이미지만 새 파일로 바꾼다(올리기 → replaceImage). 옛 객체는 서버가 커밋 뒤 지운다. */
export const useReplaceExhibitionImage = ({ onSuccess }: UseReplaceExhibitionImageOptions = {}) => {
  const uploader = useExhibitionImageUpload();
  const mutation = trpc.productManagement.exhibitions.replaceImage.useMutation({ onSuccess });

  /** 성공하면 true. 업로드 거부·서버 거부 모두 false 로 돌려준다. */
  const replaceImage = async (id: string, file: File): Promise<boolean> => {
    const imageKey = await uploader.upload(file);

    if (imageKey === null) {
      return false;
    }

    try {
      await mutation.mutateAsync({ id, imageKey });
      return true;
    } catch {
      return false;
    }
  };

  return {
    replaceImage,
    isPending: uploader.isUploading || mutation.isPending,
    /** 보여 줄 문구 — 업로드 사전 검사 실패가 먼저, 없으면 서버 거부 메시지. */
    errorMessage: uploader.error ?? mutation.error?.message ?? null,
    reset: () => {
      mutation.reset();
      uploader.clearError();
    },
  };
};
